// Auto-extracted from LangContext.jsx — single source of truth for ZH translations.
// Edit this file to update wording. Keys must stay in sync across active locales (see ACTIVE_LANGS).
/* eslint-disable */
const dict = {
  app_tagline: '篮球战术手册的未来',
  nav_dashboard: '仪表板', nav_playbook: '战术库', nav_editor: '编辑器', nav_roster: '球员',
  nav_ai: 'AI 教练', nav_live: '实时比赛', nav_simulator: '模拟器', nav_academy: '学院',
  nav_invitations: '邀请', nav_admin: '管理员', nav_pricing: '套餐',
  nav_marketplace: '市场', nav_profile: '我的资料', nav_notifications: '通知', nav_achievements: '成就',
  nav_tactile: '触控', mob_market: '市场', mob_ia: 'AI',
  login: '登录', register: '注册', logout: '登出', email: '邮箱', password: '密码',
  name: '姓名', role: '角色', coach: '教练', player: '球员', or: '或',
  welcome_back: '欢迎回来', create_account: '创建账户',
  plays: '战术', total_plays: '战术总数', active_players: '活跃球员',
  success_rate: '成功率', ai_sessions: 'AI 会话',
  search: '搜索...', all_categories: '所有类别',
  cat_man: '人盯人', cat_zone: '区域', cat_ato: 'ATO', cat_blob: 'BLOB', cat_slob: 'SLOB', cat_endgame: '终局',
  create_play: '创建战术', save: '保存', cancel: '取消', edit: '编辑', delete: '删除',
  upload_photo: '上传照片', add_player: '添加球员',
  height: '身高', weight: '体重', number: '号码', position: '位置',
  dominant_hand: '惯用手', strength: '优势', weakness: '弱点', ideal_role: '理想角色',
  generate_link: '生成邀请链接', copy_link: '复制', copied: '已复制',
  chat_placeholder: '向 AI 提问...',
  send: '发送', generate_play: '生成战术', recommend_plays: '推荐战术',
  predict_success: '预测',
  defense: '防守', moment: '时刻', recommend: '推荐',
  step: '步骤', steps: '步骤', play: '播放', stop: '停止',
  pause: '暂停', prev: '上一个', next: '下一个', loop_label: '循环', off_label: '关',
  worked: '✔ 成功', didnt_work: '✕ 失败',
  coach_premium: '教练高级', player_premium: '球员高级', academy: '学院',
  month: '月', subscribe: '订阅',
  hello: '你好', loading: '加载中...', view_all: '查看全部', back: '返回', close: '关闭', confirm: '确认',
  language: '语言', settings: '设置', not_found: '未找到',
  top_plays: '按成功率排名的顶级战术', distribution: '分布', open_ai_coach: '打开 AI 教练',
  my_roster: '我的球员', my_publications: '我的发布', no_plays_yet: '您还没有创建自己的战术',
  no_invitations_yet: '您还没有生成邀请', go_to: '前往', go_to_editor: '前往编辑器',
  dashboard_subtitle: '您的球队控制面板', greeting_morning: '早上好',
  privacy_policy: '隐私政策', terms_of_service: '服务条款',
  error_generic: '错误', invalid_credentials: '凭证无效',
  have_account: '已有账户？', no_account: '没有账户？',
  invites_subtitle: '使用您的域名生成的短链接，可追踪点击和加入数据。',
  invite_label: '标签', invite_label_placeholder: '主力队',
  invite_custom_slug: '自定义短链（可选）',
  voice: '语音', muted: '静音',
  voice_on_hint: '语音播报已开启（点击关闭）',
  voice_off_hint: '开启语音播报',
  loop_on_hint: '循环播放已开启',
  loop_off_hint: '循环播放已关闭',
  translating: '翻译中...',
  show_as: '显示为：', photo: '照片', initials: '姓名缩写',
  description_label: '描述', works_against: '适用对手',
  listen_narration: '收听讲解', tactical_simulator: '战术模拟器',
  ai_prediction: 'AI 预测', export_share: '导出与分享',
  image_label: '图片', share_whatsapp_btn: '通过 WhatsApp 分享', generating_dots: '生成中…',
  delete_confirm: '删除此战术？', deleted: '已删除',
  pdf_generated: 'PDF 已生成', image_downloaded: '图片已下载',
  frames_not_ready: '帧未就绪，请重试',
  share_error: '分享错误', image_export_error: '图片导出错误',
  pdf_export_error: 'PDF 导出错误', prediction_error: 'AI 预测错误',
  feedback_success_yes: '已标记为成功', feedback_success_no: '已标记为失败',
  feedback_error: '反馈错误', translation_error: '翻译错误',
  cached_translation: '已缓存翻译', translated_by_ai: 'AI 翻译完成',
  translated_to: '已翻译至', translate_with_ai: '使用 AI 翻译',
  whatsapp_open_attach: 'WhatsApp 已打开：请附上已下载的图片',
  reviews_title: '评论', your_review: '您的评论', publish_review: '发布评论',
  update_review: '更新',
  review_placeholder: '可选：告诉其他教练您的想法...',
  only_buyers_review: '仅购买过的教练可以评论。',
  no_reviews_yet: '还没有评论。成为第一个。',
  choose_star: '至少选 1 星', review_sent: '评论已发送',
  must_buy_review: '您必须购买此战术才能评论',
  review_singular: '条评论', review_plural: '条评论',
  editor_title: '战术创作专家',
  editor_subtitle: '兼容触控笔、手指和鼠标。选择"自由画笔"绘图。',
  blank_board: '空白战术板', templates: '模板', preview_label: '预览',
  play_name: '名称', play_description: '描述',
  category: '类别', difficulty: '难度',
  beginner: '初级', intermediate: '中级', advanced: '高级',
  pencil_free: '自由画笔',
  add_offense: '+进攻', add_defense: '+防守',
  steps_title: '步骤', add_step: '添加', step_description: '步骤描述',
  speed: '速度', delay_exit: '⏱ 出发延迟',
  assign_player_circle: '为该圆圈分配球员',
  quick_player_selection: '快速球员选择',
  animation_preview: '动画预览',
  load_template_title: '加载模板',
  export_pdf_title: '导出为 PDF',
  export_png_title: '下载为图片',
  share_whatsapp_title: '通过 WhatsApp 分享',
  clear_text: '清除', unassigned: '未分配',
  double_click_assign: '双击圆圈打开此选择器。照片+号码+姓名将显示在标记上。',
  route_timing: '路线时机',
  route_timing_desc: '每位球员的速度与延迟，用于编排挡拆、空切、双重掩护…',
  my_roster_quick: '我的球员 — 快速点击',
  players_count: '名球员',
  no_roster_yet_label: '还没有球员。请在',
  no_roster_yet_label_after: '中添加以便快速选择。',
  quick_add_hint: '点击球员立即出现在场上。双击圆圈可重新分配。',
  on_court_badge: '场上', tips_label: '提示',
  tip_offense_defense_a: '点击球场添加通用圆圈。',
  tip_pencil_a: '画出',
  tip_pencil_b: '球员路线',
  tip_pencil_c: '从其圆圈开始，系统会添加下一步。远离球员的曲线作为注释保留。',
  tip_double_tap: '双击任意圆圈重新分配给球员名单中的球员。',
  no_name: '未命名', my_new_play: '我的新战术', step_default_desc: '步骤',
  move_players: '移动球员', arrow_move: '移动箭头',
  pass_tool: '传球', dribble_tool: '运球', screen_tool: '掩护', eraser_tool: '橡皮擦',
  saved_ok: '已保存', save_error_msg: '保存错误',
  ai_hero_title: '你好，我是你的 AI 教练',
  ai_hero_subtitle: '向我请教战术、优化、预测或策略。',
  ai_powered_by: '由 PlayMaster IA 提供支持',
  ai_quick_1_label: '创建一个对抗 2-3 联防的战术',
  ai_quick_2_label: '推荐对抗人盯人的 ATO 战术',
  ai_quick_3_label: '优化 Horns Flare',
  ai_quick_1_prompt: '设计一个新战术攻击 2-3 联防。解释 3 个关键步骤以及它为什么有效。',
  ai_quick_2_prompt: '推荐 3 个对抗人盯人防守的最佳 ATO（暂停后）战术。给出理由。',
  ai_quick_3_prompt: '我有 Horns Flare 战术。如何优化间距和掩护角度，使其对换防更具杀伤力？',
  ai_connection_error: 'AI 连接错误',
  academy_title: '学院',
  academy_subtitle: '战术理念、比赛阅读和基础。点击课程查看精选的 YouTube 教学视频。',
  academy_will_open_youtube: '我们将打开 YouTube 上关于此主题的精选教学。',
  academy_watch_youtube: '在 YouTube 上观看教学',
  academy_coming_soon: '即将推出：精英教练录制的原生课程。',
  academy_lesson_1_title: '拉开空间：如何打开球场',
  academy_lesson_2_title: '如何破解 2-3 联防',
  academy_lesson_3_title: '防守挡拆：drop 与换防对比',
  academy_lesson_4_title: '比赛阅读：何时改变节奏',
  academy_lesson_5_title: 'Horns 战术执行',
  academy_lesson_6_title: '关键时刻的 BLOB 与 SLOB',
  academy_cat_fundamentals: '基础',
  academy_cat_vs_zone: '对区域防守',
  academy_cat_defense: '防守',
  academy_cat_iq: '篮球智商',
  academy_cat_systems: '战术体系',
  academy_cat_ato_blob: 'ATO/BLOB',
  pricing_h1: '提升你的比赛', pricing_subtitle: '选择适合你执教的方案。',
  plan_most_popular: '最受欢迎', payments_mocked: 'MOCKED · 支付功能将在下一版本集成 Stripe。',
  feat_playbook_full: '完整战术库（100 个战术）',
  feat_advanced_editor: '高级编辑器',
  feat_unlimited_roster: '无限球员名单',
  feat_50_ai: '每月 50 次 AI 会话',
  feat_unlimited_invites: '无限邀请',
  feat_global_plays: '访问全球战术',
  feat_didactic_photos: '带照片的教学视图',
  feat_personal_ai_coach: '个人 AI 教练',
  feat_individual_stats: '个人统计',
  feat_academy_mode: '学院模式',
  feat_100_players: '最多 100 名球员',
  feat_multi_coach: '多教练',
  feat_unlimited_ai: '无限 AI',
  feat_personal_branding: '个人品牌',
  feat_priority_support: '优先支持',
  live_h1: '实时比赛模式',
  live_subtitle: '选择对方防守和时机；AI 推荐 3 个战术。',
  live_voice_on: '语音已开 — 比赛模式', live_voice_off: '开启语音播报',
  live_voice_extra: '每个战术将逐步朗读。',
  live_defense_label: '防守：', live_moment_label: '时机：',
  live_justification: 'AI 理由', live_see_detail: '查看详情',
  def_man: '人盯人', def_zone_2_3: '2-3 区域', def_zone_3_2: '3-2 区域',
  def_zone_1_3_1: '1-3-1 区域', def_switch: '换防', def_press: '全场紧逼',
  moment_half_court: '半场', moment_ato: '暂停后（ATO）',
  moment_blob: 'BLOB（底线）', moment_slob: 'SLOB（边线）', moment_endgame: '终局',
  marketplace_seller_blurb: '您保留每笔销售的 85%。价格：$0.99 – $99.99。',
  profile_eyebrow: '资料', profile_h1: '我的教练资料',
  profile_player_h1: '我的球员资料',
  profile_player_subtitle: '你的教练在名册中看到的就是这些信息。',
  profile_player_photo_help: '当教练把你分配到战术中时，你的照片会显示在战术板上。',
  elite_verified_badge: '已认证精英教练', identity_section: '身份',
  no_photo: '无照片', upload_photo_btn: '上传照片',
  photo_help: '您的照片和资历是买家首先看到的内容。请保持专业。',
  field_display_name: '公开姓名', field_team: '球队', field_country: '国家',
  field_credentials: '资历（例如：主教练·10 年·ACB 联赛）',
  field_twitter: 'Twitter / X (@用户名)', field_instagram: 'Instagram (@用户名)',
  field_website: '网站', field_bio: '简介（告诉社区您是什么样的教练）',
  save_profile_btn: '保存资料', elite_status: '精英状态',
  verified_state: '已认证',
  elite_active_text: '您的账户是精英账户。您的战术在市场上可见。',
  elite_since: '自：', view_my_store: '查看我的店铺',
  not_elite_yet: '您还不是精英教练。申请认证以在市场上销售战术。',
  requirements_label: '要求：',
  req_bio_photo: '简介 + 专业照片', req_credentials: '可验证资历',
  req_5_plays: '至少创建 5 个自有战术',
  request_verification: '申请认证（v1 仅限管理员）',
  my_achievements: '我的成就', no_achievements: '您尚未解锁任何成就。',
  publish_in_marketplace: '发布到市场',
  unpublish_from_marketplace: '从市场移除',
  photo_uploaded: '照片已上传', upload_error: '上传错误',
  profile_saved: '资料已保存', play_published: '战术已发布到市场',
  play_unpublished: '已从市场移除',
  price_prompt: '价格（USD，0.99 到 99.99 之间）',
  sale_blurb_prompt: '简短销售描述：', purchased_badge: '（已购买）',
  landing_get_started: '开始', landing_install_app: '安装应用',
  landing_hero_subtitle: '专为篮球教练设计的首个智能战术手册。用 AI 设计、模拟和分享战术。',
  landing_feature_editor: '可视化编辑器', landing_feature_editor_desc: '用手指或触控笔绘制触感战术。自动动画。',
  landing_feature_ai: 'AI 教练', landing_feature_ai_desc: '生成战术、对任何防守推荐、预测成功率。',
  landing_feature_share: '轻松分享', landing_feature_share_desc: '导出 PDF，通过 WhatsApp 分享真实动画。',
  landing_install_short: '安装',
  landing_hero_h1_a: '篮球战术手册的', landing_hero_h1_b: '未来',
  landing_hero_para: '100 个专业战术、带真实照片的可视化编辑器、生成式与预测式 AI、名单和邀请系统。教练、球员和学院的一体化生态系统。',
  landing_stat_plays: '战术', landing_stat_languages: '语言', landing_stat_coach_24: '24/7 教练',
  landing_live_preview: '实时预览',
  landing_cap_eyebrow: '功能',
  landing_cap_h1_a: '完整的生态系统', landing_cap_h1_b: '为精英篮球而生',
  landing_f_playbook_t: '全球战术库', landing_f_playbook_d: '100 个专业战术，按人盯人、区域、ATO、BLOB、SLOB 和终局分类，带逐步动画。',
  landing_f_ai_t: 'AI 教练', landing_f_ai_d: '生成新战术，优化现有战术，预测成功率。比赛中实时推荐。',
  landing_f_roster_t: '带照片的名单', landing_f_roster_d: '上传真实照片并创建球员资料。把球员拖到球场上，打造 100% 教学式战术。',
  landing_f_langs_t: '6 种语言', landing_f_langs_d: '西班牙语、英语、法语、葡萄牙语、普通话和阿拉伯语 — 包括完整 RTL 支持。',
  landing_f_live_t: '比赛模式', landing_f_live_d: '选择对方防守和时机；AI 给出 3 个即时战术，附带战术解释。',
  landing_f_editor_t: '可视编辑器', landing_f_editor_d: 'NBA 球场、浮动工具、移动路线、掩护、切入和多步骤战术。',
  landing_cta_h1: '准备好彻底改变你的战术板了吗？', landing_cta_demo: 'Coach demo：',
  landing_cta_btn: '免费开始', contact: '联系',
  achievements_eyebrow: '成就', achievements_h1: '我的成就',
  achievements_subtitle_a: '使用应用解锁徽章。', achievements_subtitle_b: '已解锁。',
  achievements_progress: '进度', achievements_latest: '最新解锁的成就',
  achievements_no_data: '无数据。', achievements_no_yet: '开始使用应用！',
  cat_creation: '创作', cat_roster_t: '名单', cat_sales: '市场（卖家）',
  cat_buying: '市场（买家）', cat_quality: '质量', cat_status: '状态', cat_ai: 'AI',
  tier_bronze: '青铜', tier_silver: '白银', tier_gold: '黄金', tier_elite: '精英',
  no_badges_yet: '尚无成就。',
  notifications_eyebrow: '通知', notifications_h1: '通知中心',
  notif_enable_push: '启用推送', notif_test: '测试', notif_disable_push: '禁用推送',
  notif_mark_all: '全部标记', notif_empty: '暂无通知。',
  notif_marked_all: '已全部标记为已读',
  notif_push_on: '推送已启用。即使您关闭应用，我们也会通知您。',
  notif_push_off: '推送已禁用', notif_push_error: '无法启用',
  notif_test_sent: '已发送测试推送', notif_test_error: '发送测试出错',
  devices: '台设备', devices_plural: '台设备',
  market_h1: '精英战术库',
  market_subtitle: '购买经过认证教练创作的战术。每次购买都会复制一份到您的战术本。',
  market_publish_my_play: '发布我的战术',
  market_publish_my_play_title: '在市场上发布您的战术',
  market_banner_title: '您是教练吗？分享并出售您的体系',
  market_banner_body: '发布带有动画、路径和速度的战术。定价 $0.99–$99.99。每次销售您保留 85%。',
  market_banner_start: '开始 →',
  market_tab_listings: '在售战术',
  market_tab_coaches: '精英教练',
  market_tab_leaderboard: '排名 · 月度最佳教练',
  market_sort_popular: '热门',
  market_sort_recent: '最新',
  market_sort_price_asc: '价格 ↑',
  market_sort_price_desc: '价格 ↓',
  market_cat_all: '全部',
  market_empty: '该类别暂无在售战术。',
  market_sales: '销售',
  market_success: '成功率',
  market_students: '学员',
  market_plays_count: '战术',
  market_verified_elite: '认证精英',
  roster_h1: '阵容',
  roster_player_updated: '球员已更新',
  roster_player_added: '球员已添加',
  roster_save_error: '保存错误',
  roster_delete_confirm: '删除球员？（将永久移出球队。）',
  roster_block_confirm: '屏蔽该球员？他将不再是球队成员，无法查看您的战术。',
  roster_unblock_confirm: '解除屏蔽？他将重新获得您战术的访问权限。',
  roster_player_unblocked: '球员已解除屏蔽',
  roster_player_blocked: '球员已屏蔽',
  roster_action_error: '操作失败',
  roster_no_players: '您还没有球员。点击',
  roster_camera_title: '用相机拍照',
  roster_upload_gallery_title: '从相册上传',
  roster_camera_btn: '相机',
  roster_upload_btn: '上传',
  roster_photo_uploaded: '照片已上传',
  roster_photo_upload_error: '照片上传错误',
  roster_blocked_badge: '已屏蔽',
  roster_block_btn: '屏蔽',
  roster_unblock_btn: '恢复',
  roster_delete_title: '永久删除',
  roster_block_title: '屏蔽并移出球队',
  roster_unblock_title: '解除屏蔽',
  roster_no_photo: '无照片',
  roster_hand_right: '右手',
  roster_hand_left: '左手',
  roster_hand_ambi: '双手',
  roster_hand_letter_right: '右',
  roster_hand_letter_left: '左',
  roster_hand_letter_ambi: '双',
  roster_player_in_court: '已在场上',
  roster_player_added_to_court: '已添加',
  admin_h1: '管理面板',
  admin_tab_overview: '概览',
  admin_tab_users: '用户',
  admin_tab_activity: '活动',
  admin_coaches: '教练',
  admin_players: '球员',
  admin_plays_global: '全局战术',
  admin_ai_sessions: 'AI 会话',
  admin_top_plays: '热门战术',
  admin_by_category: '按类别',
  admin_col_name: '姓名',
  admin_col_email: '邮箱',
  admin_col_role: '角色',
  admin_col_created: '创建时间',
  admin_delete_user_confirm: '删除用户？',
  admin_recent_activity: '最近活动',
  sim_back_to_play: '返回战术',
  sim_eyebrow: '战术模拟器',
  sim_subtitle: 'AI 将模拟防守反应并提出具体调整建议。',
  sim_rival_defense: '对手防守',
  sim_exec_level: '执行水平',
  sim_run_now: '立即模拟',
  sim_running: '模拟中...',
  sim_ai_prediction: 'AI 预测',
  sim_confidence: '置信度:',
  sim_def_reaction: '防守如何反应',
  sim_failure_points: '失败原因',
  sim_adjustments: '推荐调整',
  sim_key_player: '球员 #1:',
  tpl_modal_eyebrow: '模板',
  tpl_modal_title: '从一个成熟体系开始',
  tpl_modal_subtitle: '预设的战术，速度与延迟已校准。可按需调整。',
  tpl_steps_count: '步',
  diff_basic: '入门',
  diff_medium: '中级',
  diff_advanced: '高级',
  editor_add_defenders: '添加防守者',
  editor_add_defenders_title: '以人盯人阵型放置 5 名防守者',
  editor_defenders_added: '已添加 5 名防守者',
  editor_defenders_already: '场上已有防守者',
  editor_remove_defenders: '移除防守',
  editor_remove_defenders_title: '从此步骤中移除 5 名防守者',
  editor_defenders_removed: '已移除防守',
  enrich_play: '✨ 丰富解说',
  regenerate_enrichment: '✨ 重新生成解说',
  enriching: '生成中...',
  enrichment_success: '战术已丰富——语音和文本现在更具教学性',
  enrichment_error: '丰富战术时出错',
  enrichment_hint: 'AI 为每个步骤生成更长、更具教学性的说明（做什么 + 为什么 + 关键提示）。语音会朗读丰富后的文本。',
  bulk_enrich_section_title: '批量丰富',
  bulk_enrich_section_body: '使用当前语言一次性丰富你的所有战术。AI 生成教学性解说（做什么 + 为什么 + 关键提示）供你的球员收听。后台运行——可关闭此窗口，进度会保留。',
  bulk_enrich_btn: '🚀 丰富我的所有战术',
  bulk_enrich_running: '正在丰富',
  bulk_enrich_hint: '为你拥有的所有战术生成当前语言的丰富解说。',
  bulk_enrich_force_label: '强制重新生成（即使已丰富）',
  bulk_enrich_in_progress: '正在丰富战术',
  bulk_enrich_done: '丰富完成！',
  bulk_enrich_done_title: '完成',
  bulk_enrich_start_error: '无法开始丰富',
  bulk_enrich_completed: '已完成',
  bulk_enrich_skipped: '已跳过（已丰富）',
  bulk_enrich_failed: '失败',
  bulk_enrich_current: '正在处理',
  bulk_enrich_errors: '错误',
  bulk_enrich_background_note: '根据战术数量，此操作可能需要数分钟。可关闭此窗口——后台会继续运行。',
};

export default dict;
